<template lang="pug">
div
  header#topnav
    .topbar-main
      .container-fluid
        // Logo container
        .logo
          // Text Logo
          a.logo(href="/webp-share/")
            span
              i.mdi.mdi-chart-pie.m-r-5
              | {{ $t('site-title') }}
        // End Logo container
        .menu-extras.topbar-custom
          ul.list-inline.float-right.mb-0
            li.list-inline-item.dropdown.notification-list.d-inline.d-lg-none
              a.nav-link.dropdown-toggle.nav-user(data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false")
                .text-lg
                  i.mdi.mdi-menu
              .dropdown-menu.dropdown-menu-right.profile-dropdown(aria-labelledby="Preview")
                a.dropdown-item.notify-item href="/webp/"
                  strong
                    | {{ $t('check-webp-share') }}
                a.dropdown-item.notify-item href="/webp/"
                  | {{ $t('webp-simulator') }}
        .clearfix
      // end container
    // end topbar-main
    .navbar-custom
      .container-fluid
        #navigation
          // Navigation Menu
          ul.navigation-menu
            li
              a(href="/webp-share/")
                .text-lg
                  i.mdi.mdi-arrow-right-box
                  | {{ $t('check-webp-share') }}
            li
              a(href="/webp/")
                | {{ $t('webp-simulator') }}
          // End navigation menu
        // end #navigation
      // end container
    // end navbar-custom
  // End Navigation Bar

</template>

<style>
.logo {
  text-transform: none !important;
}
.profile-dropdown {
  width: auto;
}
</style>

<script>
export default {
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
  },
  computed: {
  },
}
</script>

<i18n>
{
  "ja": {
    "site-title": "WebPシェアチェッカー",
    "check-webp-share": "WebPシェアをチェック",
    "webp-simulator": "WebP導入シミュレータ"
  },
  "en": {
    "site-title": "WebP Share Checker",
    "check-webp-share": "Create share report",
    "webp-simulator": "WebP Simulator"
  }
}
</i18n>